import { useEffect, useState } from 'react';
import Helmet from 'react-helmet';

import { DefaultSheet } from 'twyne-new.ui';

import sweepWinnerStore from 'modules/report/stores/sweepWinner';
import history from 'utils/history';

import Tabs from './TabsWinnerSidebar'

const WinnerSidebar = ({ match }) => {
  const [loading, setLoading] = useState(true)
  const subscriptionId = match?.params?.subscriptionId || null
  const contestWinnerId = match?.params?.contestWinnerId || null

  useEffect(() => {
    async function loadData() {
      setLoading(true)
      if (!subscriptionId || !contestWinnerId) {
        setLoading(false)
        return null
      }

      const response = await Promise.all([
        sweepWinnerStore.fetchContacts(contestWinnerId),
        sweepWinnerStore.fetchWinner(contestWinnerId),
        sweepWinnerStore.fetchTickets(subscriptionId),
      ])

      setLoading(false)
      return response
    }

    loadData()
  }, [subscriptionId, contestWinnerId])

  function handleClickSidebarClose() {
    history.push('/reports/sweep-winner');
  }

  if (!subscriptionId || !contestWinnerId) {
    return null
  }

  if (!loading) {
    const user = sweepWinnerStore.collection?.winner?.sweepSubscription?.userSession?.user || {}
    const name = `${user?.first_name || ''} ${user?.last_name || ''}`

    return <>
      <DefaultSheet
        wrapperProps={{ defaultOpen: true, onOpenChange: open => !open && handleClickSidebarClose() }}
        title={<div className='flex items-center gap-1'>
          <span>
            Winner:
          </span>
          <span className='font-bold'>
            {name}
          </span>
        </div>}
      >
        <Helmet title={name} />
        {!sweepWinnerStore.isLoading && <Tabs />}
      </DefaultSheet>
    </>
  }
}

export default WinnerSidebar;
